import { FormControl } from '@angular/forms';
import { SignInForm } from '../../models/sign-in-form/sign-in-form.interface';

export const mockSignInForm: SignInForm = {
  email: new FormControl(),
  password: new FormControl(),
};
